// test1159
(1159 && 0);
